<template>
  <canvas v-show="ready" id="totalProcessRoom" ref="totalProcessRoom" width="400" height="400"></canvas>
</template>

<script>
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";

const CHART_COLORS = {
  grey: "rgb(201, 203, 207)",
  blue: "rgb(54, 162, 235)",
  purple: "rgb(153, 102, 255)",
  green: "rgb(75, 192, 192)",
  yellow: "rgb(255, 205, 86)",
  orange: "rgb(255, 159, 64)",
  red: "rgb(255, 99, 132)"
};

export default {
  props: ["client_customer", "from_date", "to_date", "product", "process_type"],
  data() {
    return {
      ready: false,
      labels: [],
      data: [
        {
          label: "Kg",
          data: [],
          backgroundColor: Object.values(CHART_COLORS),
          borderWidth: 1,
          tension: 0.2,
          datalabels: {
            // anchor: "start",
            formatter: function (value, context) {
              const total = context.dataset.data.reduce((acc, value) => parseInt(value) + acc, 0);
              return new Intl.NumberFormat("es-CL").format(parseInt((value / total) * 100)) + " %";
            }
          }
        }
      ]
    };
  },
  async mounted() {
    const self = this;
    try {
      const response = await this.$axios({
        method: "GET",
        url: `production/dashboard/process/total_process_room?client_customer=${this.client_customer}&product=${this.product}&process_type=${this.process_type}&from_date=${this.from_date}&to_date=${this.to_date}`,
        headers: {
          "Content-Type": "application/json"
        }
      });
      this.loading = false;
      this.labels = response.data.labels;
      this.data[0].data = response.data.dataset;
      this.ready = true;
    } catch (error) {
      console.log(error);
      this.loading = false;
    }

    this.ready = true;

    let ctx = this.$refs.totalProcessRoom.getContext("2d");
    const myChart = new Chart(ctx, {
      type: "doughnut",
      data: {
        labels: this.labels,
        datasets: this.data
      },
      plugins: [ChartDataLabels],
      options: {
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: "right"
          },
          datalabels: {
            color: "#043e73"
          },
          title: {
            display: true,
            align: "start",
            text: "Total Sala/Línea"
          }
        },
        animation: {
          onComplete: function (animation) {
            setTimeout(() => {
              self.$emit("chart-ready");
            }, 500);
          }
        }
      }
    });
  }
};
</script>

<style></style>
